import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { ConsumerReportRoutingModule } from './consumer-report-routing.module';
import { RealTimeTransactionsComponent } from './real-time-transactions/real-time-transactions.component';
import { TransactionSummaryComponent } from './transaction-summary/transaction-summary.component';
import { PaymentReportComponent } from './payment-report/payment-report.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { ConsumerAcquisitionComponent } from './consumer-acquisition/consumer-acquisition.component';
import { BatchExportComponent } from './batch-export/batch-export.component';
import { FeaturesCommonModule } from 'src/app/features-common/features-common.module';
import { AgGridModule } from 'ag-grid-angular';
import { BatchExportSmartComponent } from './batch-export/batch-export-smart.component';
import { ConsumerAcquisitionSmartComponent } from './consumer-acquisition/consumer-acquisition-smart.component';
import { PaymentReportSmartComponent } from './payment-report/payment-report-smart.component';
import { TransactionSummarySmartComponent } from './transaction-summary/transaction-summary-smart.component';
import { RealTimeTransactionsSmartComponent } from './real-time-transactions/real-time-transactions-smart.component';
import { ConsumerReportComponent } from './consumer-report.component';
import { InvoicesSmartComponent } from './invoices/invoices-smart.component';
import { TransactionHistoryComponent } from './transaction-history/transaction-history.component';


@NgModule({
  declarations: [
    ConsumerReportComponent,
    RealTimeTransactionsComponent,
    TransactionSummaryComponent,
    PaymentReportComponent,
    InvoicesComponent,
    ConsumerAcquisitionComponent,
    BatchExportComponent,
    RealTimeTransactionsSmartComponent,
    TransactionSummarySmartComponent,
    PaymentReportSmartComponent,
    ConsumerAcquisitionSmartComponent,
    BatchExportSmartComponent,
    InvoicesSmartComponent,
    TransactionHistoryComponent,

  ],
  imports: [
    ConsumerReportRoutingModule,
    FeaturesCommonModule,
    AgGridModule.withComponents([]),
]
})
export class ConsumerReportModule { }
